import { Abortion } from '@/plugins/api'
import { upsertMany } from '@/helpers'
import { sortBy } from 'lodash'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    abortions: [],
    isLoading: false
  },
  actions: {
    async fetchAbortions({ commit }, options) {
      const res = await Abortion.fetch({ _sort: 'createdAt:desc', ...options })
      commit('setAbortions', res)
    },
    async fetchAbortion({ commit, state }, { id, options }) {
      const res = await Abortion.fetchOne(id, options)
      commit('setAbortions', upsertMany(state.abortions, res))
    },
    async updateAbortion({ commit, state }, { id, params, options }) {
      const res = await Abortion.update(id, params, options)
      commit(
        'setAbortions',
        sortBy(upsertMany(state.abortions, res), i => moment(i.abortion_date, 'YYYY-MM-DD').unix())
      )
    },
    async createAbortion({ commit, state }, { params, options }) {
      const res = await Abortion.create(params, options)
      commit('setAbortions', upsertMany(state.abortions, res))
    },
    async removeAbortion({ commit, state }, { id, options }) {
      await Abortion.remove(id, options)
      commit(
        'setAbortions',
        state.abortions.filter(i => i.id !== id)
      )
    }
  },
  mutations: {
    setAbortions(state, v) {
      state.abortions = v
    }
  }
}
